// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\OfferCollectionListResponse

import { hydrateOfferCollection, type OfferCollection, type OfferCollectionApiResponse } from './offerCollection.gen';

export type OfferCollectionListApiResponse = {
	items: OfferCollectionApiResponse[];
};

export type OfferCollectionList = {
	items: OfferCollection[];
};

export function hydrateOfferCollectionList(data: OfferCollectionListApiResponse): OfferCollectionList {
	return {
		...data,
		items: data.items.map(hydrateOfferCollection),
	};
}